import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { Link } from 'react-router-dom'

import { ACCOUNT_PATH } from 'config'
import { isAuthenticated } from 'modules/auth/selectors'
import { signOut } from 'modules/auth/actions'


export class UserMenu extends PureComponent {
  static propTypes = {
    isAuthenticated: PropTypes.bool.isRequired,
    signOut: PropTypes.func.isRequired,
  }

  constructor(props, context) {
    super(props, context)
    this.signOut = this.signOut.bind(this)
  }

  signOut() {
    this.props.signOut()
  }

  render() {
    if (!this.props.isAuthenticated) {
      return null
    }

    return (
      <div className="dropdown">
        <button
          className="btn btn-link"
          type="button"
          id="dropdownMenuButton"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false">
          <i className="zmdi zmdi-menu zmdi-hc-lg" />
        </button>
        <div
          className="dropdown-menu dropdown-menu-right"
          aria-labelledby="dropdownMenuButton">
          <Link to={ ACCOUNT_PATH } className="dropdown-item">Account</Link>
          <a href="#" name="sign-out" className="dropdown-item" onClick={ this.signOut }>
            Sign out
          </a>
        </div>
      </div>
    )
  }
}

export default connect(createStructuredSelector({ isAuthenticated }), { signOut })(UserMenu)



// WEBPACK FOOTER //
// ./src/components/app/user-menu.js